import React from 'react';
import { Typography } from 'antd';
import styles from './PrivacyPolicy.module.scss';

const { Title } = Typography;

const PrivacyPolicy = () => {
  return (
    // prettier-ignore
    <div className={styles.privacyPolicyContainer}>
      <Title level={3}>Privacy Policy</Title>

      <Title level={3}>(A) THIS NOTICE</Title>
      <p>
        This Notice explains how we may Process your Personal Data. This Notice may be amended or updated from time
        to time, so please check it regularly for updates.
      </p>
      <p>
        This Notice is issued by NewtonX, Inc.® (“NewtonX” or “the Company”) on behalf of itself and its affiliates
        (together, “NewtonX”, “we”, “us” and “our”) and is addressed to individuals outside our organisation with
        whom we interact, including customers, visitors to our Sites, and other users of our services (together,
        “you”). Defined terms used in this Notice are explained in Section (S) below.
      </p>
      <p>For the purposes of this Notice, NewtonX is the Controller. Contact details are provided in Section (R) below.</p>
      <p>
        This Notice may be amended or updated from time to time to reflect changes in our practices with respect to
        the Processing of Personal Data, or changes in applicable law. We encourage you to read this Notice
        carefully, and to regularly check this page to review any changes we might make in accordance with the
        terms of this Notice.
      </p>
      <br />

      <Title level={3}>(B) RECOURSE MECHANISM FOR DATA PRIVACY FRAMEWORK COMPLAINTS</Title>
      <p>
        NewtonX complies with the EU-U.S. Data Privacy Framework (EU-U.S. DPF), the UK Extension to the EU-U.S. DPF,
        and the Swiss-U.S. Data Privacy Framework (Swiss-U.S. DPF) as set forth by the U.S. Department of Commerce.
        NewtonX has certified to the U.S. Department of Commerce that it adheres to the EU-U.S. Data Privacy
        Framework Principles (EU-U.S. DPF Principles) with regard to the processing of personal data received from
        the European Union and the United Kingdom in reliance on the EU-U.S. DPF and the UK Extension to the EU-U.S.
        DPF. NewtonX has certified to the U.S. Department of Commerce that it adheres to the Swiss-U.S. Data Privacy
        Framework Principles (Swiss-U.S. DPF Principles) with regard to the processing of personal data received
        from Switzerland in reliance on the Swiss-U.S. DPF. If there is any conflict between the terms in this
        privacy policy and the DPF Principles and/or the Swiss-U.S. DPF Principles (DPF Principles), the Principles
        shall govern. To learn more about the Data Privacy Framework Program (DPF Program), and to view our
        certification, please visit{' '}
        <a href="https://www.dataprivacyframework.gov/" target="_blank" rel="noopener noreferrer">
          https://www.dataprivacyframework.gov/
        </a>
        .
      </p>
      <p>
        The Data Privacy Framework certification and the practices described in this privacy policy apply only to
        NewtonX, Inc.® and do not cover any subsidiaries or affiliated entities.
      </p>
      <p>
        With respect to personal data received or transferred pursuant to the DPF Program, NewtonX is subject to the
        investigatory and enforcement powers of the U.S. Federal Trade Commission.
      </p>
      <p>
        Pursuant to the DPF Program, EU, UK, and Swiss individuals have the right to obtain our confirmation of
        whether we maintain personal information relating to you in the United States. Upon request, we will provide
        you with access to the personal information that we hold about you. You may also correct, amend, or delete
        the personal information we hold about you. An individual who seeks access, or who seeks to correct, amend,
        or delete inaccurate data transferred to the United States in reliance on the DPF Program should direct
        their query to experts@newtonx.com. If requested to remove data, we will respond within a reasonable
        timeframe.
      </p>
      <p>
        We will provide an individual opt-out choice, or opt-in for sensitive data, before we share your data with
        third parties other than our agents, or before we use it for a purpose other than which it was originally
        collected or subsequently authorized. To request to limit the use and disclosure of your personal
        information, please submit a written request to experts@newtonx.com.
      </p>
      <p>
        In certain situations, we may be required to disclose personal data in response to lawful requests by
        public authorities, including to meet national security or law enforcement requirements.
      </p>
      <p>
        If you are an EU, UK, or Swiss Individual, where we transfer your personal data to third party service
        providers who perform services for us or on our behalf, we are responsible for the processing of that data
        by them and shall remain liable if they process your personal data in a manner inconsistent with the DPF
        Principles, unless we prove that we are not responsible for the event giving rise to the damage.
      </p>
      <p>
        In compliance with the DPF Principles, NewtonX commits to resolve DPF Principles-related complaints about
        your privacy and our collection or use of your personal information. European Union, United Kingdom, and
        Swiss individuals with inquiries or complaints regarding our handling of personal data in reliance on the
        DPF should first contact NewtonX at: experts@newtonx.com.
      </p>
      <p>
        NewtonX has further committed to refer unresolved DPF Principles-related complaints to a U.S.-based
        independent dispute resolution mechanism, BBB NATIONAL PROGRAMS. If you do not receive timely acknowledgment
        of your complaint, or if your complaint is not satisfactorily addressed by us, please visit{' '}
        <a href="https://www.bbbprograms.org/dpf-complaints" target="_blank" rel="noopener noreferrer">
          www.bbbprograms.org/dpf-complaints
        </a>{' '}
        for more information and to file a complaint. This service is provided free of charge to you.
      </p>
      <p>
        If your DPF complaint cannot be resolved through the above channels, under certain conditions, you may
        invoke binding arbitration for some residual claims not resolved by other redress mechanisms. See{' '}
        <a
          href="https://www.dataprivacyframework.gov/framework-article/ANNEX-I-introduction"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://www.dataprivacyframework.gov/framework-article/ANNEX-I-introduction
        </a>{' '}
        for more information on this process.
      </p>
      <p>
        In compliance with the EU-U.S. DPF and the UK Extension to the EU-U.S. DPF and the Swiss-U.S. DPF, NewtonX,
        Inc.® commits to cooperate and comply with the advice of the panel established by the EU data protection
        authorities (DPAs), the UK Information Commissioner’s Office (ICO), and the Swiss Federal Data Protection and
        Information Commissioner (FDPIC) with regard to unresolved complaints concerning our handling of human
        resources data received in reliance on the EU-U.S. DPF, the UK Extension to the EU-U.S. DPF, and the
        Swiss-U.S. DPF in the context of the employment relationship.
      </p>
      <br />

      <Title level={3}>(C) COLLECTION OF PERSONAL DATA</Title>
      <p>
        We may collect or obtain Personal Data about you: directly from you (e.g., where you contact us); in the
        course of our relationship with you (e.g., if you make a purchase); when you visit our Sites; when you
        register to use any of our Sites, or services; or when you interact with any third party content or
        advertising on a Site. We may also receive Personal Data about you from third parties (e.g., law enforcement
        authorities).
      </p>
      <p>We may collect Personal Data about you from the following sources:</p>
      <ul>
        <li>Data you provide: We may obtain your Personal Data when you provide it to us (e.g., where you contact us via email or telephone).</li>
        <li>Relationship data: We may collect or obtain your Personal Data in the ordinary course of our relationship with you (e.g., we provide a service to you, or to your employer).</li>
        <li>Expert data: We may collect or obtain your Personal Data if you apply to become an Expert.</li>
        <li>Registration details: We may collect or obtain your Personal Data when you use, or register to use, any of our Sites or services.</li>
      </ul>
      <br />

      <Title level={3}>(D) CREATION OF PERSONAL DATA</Title>
      <ul>
        <li>We may create Personal Data about you (e.g., records of your interactions with us).</li>
        <li>We may also create Personal Data about you, such as records of your interactions with us, our clients, or our Experts.</li>
      </ul>
      <br />

      <Title level={3}>(E) CATEGORIES OF PERSONAL DATA WE MAY PROCESS</Title>
      <p>
        We may Process: your personal details (e.g., your name, biographical information); demographic data; your
        contact details (e.g., your address); records of your consents; payment details; information about our
        Sites (e.g., the type of device you are using); details of your employer (where relevant); information about
        your interactions with our content or advertising; and any views or opinions you provide to us.
      </p>
      <p>We may Process the following categories of Personal Data about you:</p>
      <ul>
        <li>Personal details: given name(s); preferred name; and photograph (if provided).</li>
        <li>Demographic information: date of birth; salutation; title; and language preferences.</li>
        <li>Expert data: With respect to Experts (in addition to any other applicable category set out in this Notice), payment information, professional biography, and other profiling information pertaining to your experience and expertise.</li>
        <li>Contact details: address; telephone number; email address; and details of your public business networking profile(s) or online biographies.</li>
        <li>Consent records: records of any consents you may have given, together with the date and time, means of consent and any related information (e.g., the subject matter of the consent).</li>
        <li>Employer details: where you interact with us in your capacity as an employee, the name, address, telephone number and email address of your employer, to the extent relevant.</li>
        <li>Views and opinions: any views and opinions that you choose to send to us.</li>
      </ul>
      <br />

      <Title level={3}>(F) LEGAL BASIS FOR PROCESSING PERSONAL DATA</Title>
      <p>
        We may Process your Personal Data where: you have given your prior, express consent; the Processing is
        necessary for a contract between you and us; the Processing is required by applicable law; the Processing is
        necessary to protect the vital interests of any individual; or where we have a valid legitimate interest in
        the Processing.
      </p>
      <p>
        In Processing your Personal Data in connection with the purposes set out in this Notice, we may rely on one
        or more of the following legal bases, depending on the circumstances:
      </p>
      <ul>
        <li>Consent: We may Process your Personal Data where we have obtained your prior, express consent to the Processing (this legal basis is only used in relation to Processing that is entirely voluntary – it is not used for Processing that is necessary or obligatory in any way);</li>
        <li>Contractual necessity: We may Process your Personal Data where the Processing is necessary in connection with any contract that you may enter into with us (for instance if you are a NewtonX Expert, have applied for Expert membership, or are a NewtonX client);</li>
        <li>Compliance with applicable law: We may Process your Personal Data where the Processing is required by applicable law;</li>
        <li>Vital interests: We may Process your Personal Data where the Processing is necessary to protect the vital interests of any individual; or</li>
        <li>
          Legitimate interests: We may Process your Personal Data where we have a legitimate interest in the
          Processing. The balancing test we have conducted in each case is as follows:
          <ul>
            <li>we have ensured that the Processing is lawful, proportionate, and conducted in accordance with the terms of this Notice;</li>
            <li>we have ensured that we have a legitimate business need to perform the Processing; and</li>
            <li>we have ensured that there is no material likelihood of any adverse impact on your interests, fundamental rights, or freedoms, as a result of the Processing.</li>
          </ul>
        </li>
      </ul>
      <br />

      <Title level={3}>(G) SENSITIVE PERSONAL DATA</Title>
      <p>
        We do not seek to collect or otherwise Process your Sensitive Personal Data. Where we need to Process your
        Sensitive Personal Data for a legitimate purpose, we do so in accordance with applicable law.
      </p>
      <p>
        We do not seek to collect or otherwise Process Sensitive Personal Data in the ordinary course of our
        business. Where it becomes necessary to Process your Sensitive Personal Data for any reason, we rely on one
        of the following legal bases:
      </p>
      <ul>
        <li>Compliance with applicable law: We may Process your Sensitive Personal Data where the Processing is required or permitted by applicable law (e.g., to comply with our diversity reporting obligations);</li>
        <li>Detection and prevention of crime: We may Process your Sensitive Personal Data where the Processing is necessary for the detection or prevention of crime (including the prevention of fraud);</li>
        <li>Establishment, exercise or defence of legal rights: We may Process your Sensitive Personal Data where the Processing is necessary for the establishment, exercise or defence of legal rights; or</li>
        <li>Consent: We may Process your Sensitive Personal Data where we have, in accordance with applicable law, obtained your prior, express consent prior to Processing your Sensitive Personal Data (this legal basis is only used in relation to Processing that is entirely voluntary – it is not used for Processing that is necessary or obligatory in any way).</li>
      </ul>
      <p>
        If you provide Sensitive Personal Data to us, you must ensure that it is lawful for you to disclose such
        data to us, including ensuring that one of the legal bases set out above is available to us with respect to
        the Processing of those Sensitive Personal Data.
      </p>
      <br />

      <Title level={3}>(H) PURPOSES FOR WHICH WE MAY PROCESS YOUR PERSONAL DATA</Title>
      <p>
        We may Process your Personal Data for the following purposes: providing services to you; compliance checks;
        operating our Sites; communicating with you; managing our IT systems; financial management; conducting
        surveys; ensuring the security of our premises and systems; conducting investigations where necessary;
        compliance with applicable law; and improving our Sites, and services.
      </p>
      <p>We may Process your Personal Data for the following purposes, subject to applicable law:</p>
      <ul>
        <li>Provision of services: providing our Sites or services; providing services on request; and communicating with you in relation to those services.</li>
        <li>Our Sites: operating and managing our Sites; providing content to you; displaying advertising and other information to you; communicating and interacting with you via our Sites; and notifying you of changes to any of our Sites, or our services.</li>
        <li>Experts: communicating with you regarding your Expert membership (or prospective Expert membership), where applicable, to provide you with opportunities to participate in projects, and to keep you up to date with new developments at NewtonX.</li>
        <li>Communications: communicating with you via any means (including via email, telephone, text message, social media, post or in person) information in which you may be interested (e.g., upcoming NewtonX events, new product offerings, information relevant to you as a NewtonX client or Expert), subject to ensuring that such communications are provided to you in compliance with applicable law; maintaining and updating your contact information where appropriate; and obtaining your prior, opt-in consent where required.</li>
        <li>Communications and IT operations: management of our communications systems; operation of IT security systems; and IT security audits.</li>
        <li>Financial management: sales; finance; corporate audit; and vendor management.</li>
        <li>Surveys: engaging with you for the purposes of obtaining your views on our services.</li>
        <li>Security: physical security of our premises (including records of visits to our premises; and CCTV recordings); and electronic security (including login records and access details).</li>
        <li>Investigations: detecting, investigating and preventing breaches of policy, fraud, and violations of law, in accordance with applicable law.</li>
        <li>Legal proceedings: establishing, exercising and defending legal rights.</li>
        <li>Legal compliance: compliance with our legal and regulatory obligations under applicable law.</li>
        <li>Improving our Sites, services: identifying issues with our Sites, or our services; planning improvements to our Sites, or our services; and creating new Sites, or services.</li>
      </ul>
      <br />

      <Title level={3}>(I) DISCLOSURE OF PERSONAL DATA TO THIRD PARTIES</Title>
      <p>
        We may disclose your Personal Data to: legal and regulatory authorities; our external advisors; our
        Processors; any party as necessary in connection with legal proceedings; any party as necessary for
        investigating, detecting or preventing criminal offences; any purchaser of our business; and any third party
        providers of advertising, plugins or content used on our Sites.
      </p>
      <p>
        We may disclose your Personal Data to other entities within the NewtonX group, for legitimate business
        purposes (including operating our Sites, and providing services to you), in accordance with applicable law.
        In addition, we may disclose your Personal Data to:
      </p>
      <ul>
        <li>you and, where appropriate, your appointed representatives;</li>
        <li>legal and regulatory authorities, upon request, or for the purposes of reporting any actual or suspected breach of applicable law or regulation;</li>
        <li>accountants, auditors, lawyers and other outside professional advisors to NewtonX, subject to binding contractual obligations of confidentiality;</li>
        <li>third party Processors (such as payment services providers; survey partners, marketing outreach providers, cloud service providers, etc.), located anywhere in the world, subject to the requirements noted below in this Section (I);</li>
        <li>any relevant party, law enforcement agency or court, to the extent necessary for the establishment, exercise or defence of legal rights;</li>
        <li>any relevant party for the purposes of prevention, investigation, detection or prosecution of criminal offences or the execution of criminal penalties;</li>
        <li>any relevant party if we believe disclosure is necessary and appropriate to prevent physical, financial, or other harm, injury, or loss;</li>
        <li>any relevant third party acquirer(s), in the event that we sell or transfer all or any relevant portion of our business or assets (including in the event of a reorganization, dissolution or liquidation); and</li>
        <li>any relevant third party provider, where our Sites use third party advertising, plugins or content. If you choose to interact with any such advertising, plugins or content, your Personal Data may be shared with the relevant third party provider. We recommend that you review that third party’s privacy policy before interacting with its advertising, plugins or content.</li>
      </ul>
      <p>
        If we engage a third-party Processor to Process your Personal Data, the Processor will be subject to
        binding contractual obligations to: (i) only Process the Personal Data in accordance with our prior written
        instructions; and (ii) use measures to protect the confidentiality and security of the Personal Data;
        together with any additional requirements under applicable law.
      </p>
      <br />

      <Title level={3}>(J) INTERNATIONAL TRANSFER OF PERSONAL DATA</Title>
      <p>
        We may transfer your Personal Data to recipients in other countries. Where we transfer Personal Data from
        the EEA to a recipient outside the EEA that is not in an Adequate Jurisdiction, we do so on the basis of
        Standard Contractual Clauses.
      </p>
      <p>
        Because of the international nature of our business, we may need to transfer your Personal Data within the
        NewtonX group, and to third parties as noted in Section (I) above, in connection with the purposes set out
        in this Notice. For this reason, we may transfer your Personal Data to other countries that may have
        different laws and data protection compliance requirements to those that apply in the country in which you
        are located.
      </p>
      <p>
        Where we transfer your Personal Data from the EEA to recipients located outside the EEA who are not in
        Adequate Jurisdictions, we do so on the basis of Standard Contractual Clauses. You may request a copy of our
        Standard Contractual Clauses using the contact details provided in Section (R) below.
      </p>
      <p>
        If you are located outside of the United States, you should be aware that the Personal Data you provide to
        us is being transmitted to us and Processed in the United States, and will be protected subject to this
        privacy policy and United States laws, which may not be as protective as the laws in your country. Please
        note that when you transfer any Personal Data directly to a NewtonX entity established outside the EEA, we
        are not responsible for that transfer of your Personal Data. We will nevertheless Process your Personal
        Data, from the point at which we receive those data, in accordance with the provisions of this Notice.
      </p>
      <br />

      <Title level={3}>(K) DATA SECURITY</Title>
      <p>
        We implement appropriate technical and organisational security measures to protect your Personal Data.
        Please ensure that any Personal Data that you send to us are sent securely.
      </p>
      <p>
        We have implemented appropriate technical and organisational security measures designed to protect your
        Personal Data against accidental or unlawful destruction, loss, alteration, unauthorised disclosure,
        unauthorised access, and other unlawful or unauthorised forms of Processing, in accordance with applicable
        law.
      </p>
      <p>
        Because the internet is an open system, the transmission of information via the internet is not completely
        secure. Although we will implement all reasonable measures to protect your Personal Data, we cannot
        guarantee the security of your data transmitted to us using the internet – any such transmission is at your
        own risk and you are responsible for ensuring that any Personal Data that you send to us are sent securely.
      </p>
      <br />

      <Title level={3}>(L) DATA ACCURACY</Title>
      <p>
        We take every reasonable step to ensure that your Personal Data is kept accurate and up-to-date and is
        erased or rectified if we become aware of inaccuracies.
      </p>
      <ul>
        <li>Your Personal Data that we Process are accurate and, where necessary, kept up to date; and</li>
        <li>any of your Personal Data that we Process that are inaccurate (having regard to the purposes for which they are Processed) are erased or rectified without delay.</li>
        <li>From time to time we may ask you to confirm the accuracy of your Personal Data.</li>
      </ul>
      <br />

      <Title level={3}>(M) DATA MINIMIZATION</Title>
      <p>
        We take every reasonable step to limit the volume of your Personal Data that we Process to what is
        necessary. We take every reasonable step to ensure that your Personal Data that we Process are limited to
        the Personal Data reasonably necessary in connection with the purposes set out in this Notice.
      </p>
      <br />

      <Title level={3}>(N) DATA RETENTION</Title>
      <p>
        We take every reasonable step to ensure that your Personal Data are only retained for as long as they are
        needed in connection with a lawful purpose.
      </p>
      <p>
        We take every reasonable step to ensure that your Personal Data are only Processed for the minimum period
        necessary for the purposes set out in this Notice. The criteria for determining the duration for which we
        will retain your Personal Data are as follows:
      </p>
      <ol type="1">
        <li>
          we will retain copies of your Personal Data in a form that permits identification only for as long as:
          <ol type="a">
            <li>we maintain an ongoing relationship with you (e.g., where you are a user of our services, are a Expert (or have applied to become one), or you are lawfully included in our mailing list and have not unsubscribed);</li>
            <li>should you cease being a Expert, six (6) years from your most recent interaction with any NewtonX client; or</li>
            <li>your Personal Data are necessary in connection with the lawful purposes set out in this Notice, for which we have a valid legal basis (e.g., where we have a legitimate interest in processing your data for the purposes of operating our business and fulfilling our obligations under a contract),</li>
          </ol>
          plus:
        </li>
        <li>
          the duration of:
          <ol type="a">
            <li>any applicable limitation period under applicable law (i.e., any period during which any person could bring a legal claim against us in connection with your Personal Data, or to which your Personal Data may be relevant); and</li>
            <li>an additional two (2) month period following the end of such applicable limitation period (so that, if a person bring a claim at the end of the limitation period, we are still afforded a reasonable amount of time in which to identify any Personal Data that are relevant to that claim), and:</li>
          </ol>
        </li>
        <li>in addition, if any relevant legal claims are brought, we may continue to Process your Personal Data for such additional periods as are necessary in connection with that claim.</li>
      </ol>
      <p>
        During the periods noted in paragraphs (2)(a) and (2)(b) above, we will restrict our Processing of your
        Personal Data to storage of, and maintaining the security of, those data, except to the extent that those
        data need to be reviewed in connection with any legal claim, or any obligation under applicable law.
      </p>
      <p>Once the periods in paragraphs (1), (2) and (3) above, each to the extent applicable, have concluded, we will either:</p>
      <ul>
        <li>permanently delete or destroy the relevant Personal Data; or</li>
        <li>anonymize the relevant Personal Data.</li>
      </ul>
      <br />

      <Title level={3}>(O) YOUR LEGAL RIGHTS</Title>
      <p>
        Under applicable law, you may have a number of rights, including: the right not to provide your Personal
        Data to us; the right of access to your Personal Data; the right to request rectification of inaccuracies;
        the right to request the erasure, or restriction of Processing, of your Personal Data; the right to object
        to the Processing of your Personal Data; the right to have your Personal Data transferred to another
        Controller; the right to withdraw consent; and the right to lodge complaints with Data Protection
        Authorities. We may require proof of your identity before we can give effect to these rights.
      </p>
      <p>
        Subject to applicable law, you may have a number of rights regarding the Processing of your Relevant
        Personal Data, including:
      </p>
      <ul>
        <li>the right not to provide your Personal Data to us (however, please note that we may be unable to provide you with the full benefit of our Sites, or our services, if you do not provide us with your Personal Data – e.g., we may not be able to process your orders without the necessary details);</li>
        <li>the right to request access to, or copies of, your Relevant Personal Data, together with information regarding the nature, Processing and disclosure of those Relevant Personal Data;</li>
        <li>the right to request rectification of any inaccuracies in your Relevant Personal Data;</li>
        <li>
          the right to request, on legitimate grounds:
          <ul>
            <li>erasure of your Relevant Personal Data; or restriction of Processing of your Relevant Personal Data;</li>
          </ul>
        </li>
        <li>the right to object, on legitimate grounds, to the Processing of your Relevant Personal Data by us or on our behalf;</li>
        <li>the right to have certain Relevant Personal Data transferred to another Controller, in a structured, commonly used and machine-readable format, to the extent applicable;</li>
        <li>where we Process your Relevant Personal Data on the basis of your consent, the right to withdraw that consent (noting that such withdrawal does not affect the lawfulness of any Processing performed prior to the date on which we receive notice of such withdrawal, and does not prevent the Processing of your Personal Data in reliance upon any other available legal bases); and</li>
        <li>
          the right to lodge complaints regarding the Processing of your Relevant Personal Data with a Data
          Protection Authority (in particular, the Data Protection Authority of the EU Member State in which you
          live, or in which you work, or in which the alleged infringement occurred, each if applicable). A list of
          Supervisory Authorities is available here:{' '}
          <a href="https://edpb.europa.eu/about-edpb/board/members_en" target="_blank" rel="noopener noreferrer">
            https://edpb.europa.eu/about-edpb/board/members_en
          </a>
          .
        </li>
      </ul>
      <p>This does not affect your statutory rights.</p>
      <p>
        To exercise one or more of these rights, or to ask a question about these rights or any other provision of
        this Notice, or about our Processing of your Personal Data, please use the contact details provided in
        Section (R) below. Please note that: we may require proof of your identity before we can give effect to
        these rights; and where your request requires the establishment of additional facts (e.g., a determination
        of whether any Processing is non-compliant with applicable law) we will investigate your request reasonably
        promptly, before deciding what action to take.
      </p>
      <br />

      <Title level={3}>(P) COOKIES AND SIMILAR TECHNOLOGIES</Title>
      <p>
        We may Process your Personal Data by placing or reading Cookies and similar technologies. For more
        information, please see our Cookie Policy.
      </p>
      <p>
        When you visit a Site we may place Cookies onto your device, or read Cookies already on your device, subject
        always to obtaining your consent, where required, in accordance with applicable law. We use Cookies to
        record information about your device, your browser and, in some cases, your preferences and browsing
        habits. We may Process your Personal Data through Cookies and similar technologies, in accordance with our
        Cookie Policy.
      </p>
      <br />

      <Title level={3}>(Q) DIRECT MARKETING</Title>
      <p>
        We may Process your Personal Data to contact you with information regarding services that may be of
        interest to you. You may unsubscribe for free at any time.
      </p>
      <p>
        We may Process your Personal Data to contact you via email, telephone, direct mail or other communication
        formats to provide you with information regarding services that may be of interest to you. If we provide
        services to you, we may send information to you regarding our services, upcoming promotions and other
        information that may be of interest to you, using the contact details that you have provided to us and
        always in compliance with applicable law.
      </p>
      <p>
        You may unsubscribe from our promotional email list at any time by simply clicking on the unsubscribe link
        included in every promotional email we send. After you unsubscribe, we will not send you further
        promotional emails, but we may continue to contact you to the extent necessary for the purposes of any
        services you have requested.
      </p>
      <br />

      <Title level={3}>(R) CONTACT DETAILS</Title>
      <p>
        If you have any comments, questions or concerns about any of the information in this Notice, or any other
        issues relating to the Processing of Personal Data carried out by us, or on our behalf, please contact:
      </p>
      <ul>
        <li>Legal Department, NewtonX, Inc., 60 East 42nd Street, 3rd Floor, New York, NY 10165</li>
        <li>Phone: (212) 984-8500</li>
        <li>Fax: (212) 984-2485</li>
        <li>Email: privacy@newtonx.com</li>
      </ul>
      <br />

      <Title level={3}>(S) DEFINITIONS</Title>
      <p>
        <b>“Adequate Jurisdiction”</b> means a jurisdiction that has been formally designated by the European
        Commission as providing an adequate level of protection for Personal Data.
      </p>
      <p>
        <b>“Cookie”</b> means a small file that is placed on your device when you visit a website (including our
        Sites). In this Notice, a reference to a “Cookie” includes analogous technologies such as web beacons and
        clear GIFs.
      </p>
      <p>
        <b>“Controller”</b> means the entity that decides how and why Personal Data are Processed. In many
        jurisdictions, the Controller has primary responsibility for complying with applicable data protection laws.
      </p>
      <p>
        <b>“Expert”</b> means any person who has executed a version of the NewtonX Terms & Conditions of Expert
        membership and not had their membership discontinued (either by NewtonX or at their request).
      </p>
      <p>
        <b>“Data Protection Authority”</b> means an independent public authority that is legally tasked with
        overseeing compliance with applicable data protection laws.
      </p>
      <p>
        <b>“EEA”</b> means the European Economic Area.
      </p>
      <p>
        <b>“Personal Data”</b> means information that is about any individual, or from which any individual is
        directly or indirectly identifiable, in particular by reference to an identifier such as a name, an
        identification number, location data, an online identifier or to one or more factors specific to the
        physical, physiological, genetic, mental, economic, cultural or social identity of that individual.
      </p>
      <p>
        <b>“Process”, “Processing” or “Processed”</b> means anything that is done with any Personal Data, whether or
        not by automated means, such as collection, recording, organisation, structuring, storage, adaptation or
        alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making
        available, alignment or combination, restriction, erasure or destruction.
      </p>
      <p>
        <b>“Processor”</b> means any person or entity that Processes Personal Data on behalf of the Controller
        (other than employees of the Controller).
      </p>
      <p>
        <b>“Profiling”</b> means any form of automated Processing of Personal Data consisting of the use of Personal
        Data to evaluate certain personal aspects relating to a natural person, in particular to analyse or predict
        aspects concerning that natural person’s performance at work, economic situation, health, personal
        preferences, interests, reliability, behaviour, location or movements.
      </p>
      <p>
        <b>“Relevant Personal Data”</b> means Personal Data in respect of which we are the Controller.
      </p>
      <p>
        <b>“Sensitive Personal Data”</b> means Personal Data about race or ethnicity, political opinions, religious
        or philosophical beliefs, trade union membership, physical or mental health, sexual life, any actual or
        alleged criminal offences or penalties, national identification number, or any other information that may
        be deemed to be sensitive under applicable law.
      </p>
      <p>
        <b>“Standard Contractual Clauses”</b> means template transfer clauses adopted by the European Commission or
        adopted by a Data Protection Authority and approved by the European Commission.
      </p>
      <p>
        <b>“Site”</b> means any website operated, or maintained, by us or on our behalf.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
